import ErrorPage from '#client/pages/Error';

export default function NotFound() {
  // FIXME: Need a real 404 page, as Error is for 500s
  return <ErrorPage>The requested page could not be found.</ErrorPage>;
}
